import { useNavigate, Navigate } from "react-router";
import { useEffect } from "react";
import { useCurrentUser } from "@/features/login/hooks/useCurrentUser";
import {
  button,
  card,
  container,
  description,
  errorCode,
  homeIcon,
  title,
} from "./notFound.css";

const NotFound = () => {
  const navigate = useNavigate();
  const { user } = useCurrentUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", window.location.pathname);
  }, []);

  const getHomePath = () => {
    const roleName = user.rol?.nombre;
    switch (roleName) {
      case "APRENDIZ":
        return "/programas";
      case "CLIENTE":
        return "/cliente";
      case "INTERMEDIO":
        return "/intermediario/vista-general";
      case "SUPER_ADMIN":
        return "/admin/vista-general";
      default:
        return "/";
    }
  };

  const homePath = getHomePath();

  return (
    <div className={container}>
      <div className={card}>
        <div className={errorCode}>404</div>
        <h1 className={title}>Página no encontrada</h1>
        <p className={description}>
          Lo sentimos, no pudimos encontrar la página que estás buscando.
          Es posible que la página haya sido movida o eliminada.
        </p>
        <button className={button} onClick={() => navigate(homePath)}>
          <svg
            className={homeIcon}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
            />
          </svg>
          Ir al inicio
        </button>
      </div>
    </div>
  );
};

export default NotFound;
